import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
/* import { GET_VIEWstudentlist } from '../../actions'; */
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class View extends Component {
  
  constructor(props)
  {
    super(props); 
    const userid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

    this.state = {      
      userid: userid,
      studentlistview:'',
      familtlistview:'',
    };

    axios.get(apiUrl+"student/listdetail?id="+userid).then(res => {
			if(res.data.status == 'success'){
				const formdata = res.data.studentlist;
			if(formdata.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

			}
			this.setState({studentlistview:res.data.studentlist});
						
			}
			
		}); 
  }

   
   componentDidMount() {
     document.title = PageTitle('Student View');
   }

   componentDidUpdate(prevProps,prevState){

   }
   componentWillReceiveProps(Props){
   
    
   }
   
  render() {
    

    var mobileno = ((this.state.studentlistview.mobile === null)||((this.state.studentlistview.mobile === ''))) ?  this.state.studentlistview.mobile = 'N/A' : this.state.studentlistview.mobile;
    var address = ((this.state.studentlistview.address === null)||((this.state.studentlistview.address === ''))) ?  this.state.studentlistview.address = 'N/A' : this.state.studentlistview.address;
    var university = ((this.state.studentlistview.university === null)||((this.state.studentlistview.university === ''))) ?  this.state.studentlistview.university = 'N/A' : this.state.studentlistview.university;
    var grade = ((this.state.studentlistview.grade === null)||((this.state.studentlistview.grade === ''))) ?  this.state.studentlistview.grade = 'N/A' : this.state.studentlistview.grade;

    var lastname = ((this.state.studentlistview.lastname === null)||(this.state.studentlistview.lastname === "")) ?  this.state.studentlistview.lastname = 'N/A' : this.state.studentlistview.lastname;

    if(this.state.studentlistview.status == 'A'){
      var status = 'Active';
    }else{
        var status = 'Inactive';
    }
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="student" />  
      
      <div className="content"> 
        <div className="content-wrapper">
         <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card">
               <div>
				<a className="add" href='/student'>Back</a> 
			</div>
                <div className="title">
                  <h3>Student Details</h3>
                </div>
                <div className="form-row">
                    <div className="details_left">
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>User Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.studentlistview.username}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>First Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.studentlistview.firstname}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Last Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{lastname}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Email<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.studentlistview.email}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Contact<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{mobileno}</p>
                          </div>
                          
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Address<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{address}</p>
                          </div>
                          
                        </div>
                        {/* <div className="view-details">
                          <div className="view-details-one">
                              <p><b>University<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{university}</p>
                          </div>
                          
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Grade<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{grade}</p>
                          </div>
                          
                        </div> */}
                        {/* <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Domain<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                          <p>{this.state.studentlistview.domain_name}</p>
                          </div>
                          
                        </div> */}
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Status<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{status}</p>
                          </div>
                          
                        </div>

                      
                        



                    </div>
                </div>
                 
                  
               
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}
export default withRouter(View);
